/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_FtpInputs */

const en_ui_color_by_reason_ftp = /** @type {(inputs: Ui_Color_By_Reason_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your FTP in your profile`)
};

const de_ui_color_by_reason_ftp = /** @type {(inputs: Ui_Color_By_Reason_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trag deine FTP in deinem Profil ein`)
};

/**
* | output |
* | --- |
* | "Set your FTP in your profile" |
*
* @param {Ui_Color_By_Reason_FtpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_ftp = /** @type {((inputs?: Ui_Color_By_Reason_FtpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_FtpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_ftp(inputs)
	return de_ui_color_by_reason_ftp(inputs)
});